import { createSlice } from '@reduxjs/toolkit';

import { mainPageApi } from '@/components/App/main-page/api/main-page-api';
import type { StrictOmit } from '@/types/app';

import type { TBankSummaryStore } from '../types/store';
import { createAsyncThunk } from './create-async-thunk';

const initialState: TBankSummaryStore = {
  summary: null
};

export type TBankSummaryFilters = {
  bankUuid: string;
  dateFrom: string;
  dateTo: string;
};

export const getBankSummary = createAsyncThunk(
  'main/getBankSummary',
  async (filters: TBankSummaryFilters) => {
    return mainPageApi.getBankSummary(filters);
  }
);

export const getBankSummaryTotal = createAsyncThunk(
  'main/getBankSummaryTotal',
  async (filters: StrictOmit<TBankSummaryFilters, 'bankUuid'>) => {
    return mainPageApi.getBankSummaryTotal(filters);
  }
);

export const bankSummarySlice = createSlice({
  name: 'bankSummary',
  initialState,
  reducers: {
    resetSummary: (state) => {
      state.summary = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBankSummary.fulfilled, (state, action) => {
        state.summary = action.payload[0] || null;
      })
      .addCase(getBankSummaryTotal.fulfilled, (state, action) => {
        state.summary = action.payload[0] || null;
      });
  }
});

export const { resetSummary } = bankSummarySlice.actions;
